import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import CrossAssetAnalysisV2Component from './CrossAssetAnalysisV2Component';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import { clearStore, saveOnGraphToOffGraph, onGraphClearStore, setSelectedAsset, loadCapabilityAndKPIs, setBrowserCategory } from './actions';
import { resetChart } from '../../PowertrainAssetDetails/CrossAssetAnalysis/ChartView/actions';
import { normalizeCrossAssetV2Asset } from './helpers/assetIdentity';
import { browserCategories } from './constants';
import { handleRemoveQueryParams } from '../ConditionIndicesOverviewV2/helpers';

const getConditionOverviewSelectedAsset = ({ conditionIndicesV2 }) => conditionIndicesV2?.selectedAsset;

const CrossAssetAnalysisV2Container = ({ actions }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const conditionOverviewSelectedAsset = useSelector(getConditionOverviewSelectedAsset);

    useEffect(() => {
        // clear any chartData left by V1 in the shared store when V2 mounts
        actions.resetChart();

        // Carry over the asset opened in Condition Overview so it arrives pre-selected/expanded here
        const carriedOverAsset = normalizeCrossAssetV2Asset(conditionOverviewSelectedAsset);
        if (carriedOverAsset?.id) {
            dispatch(setBrowserCategory(browserCategories.ASSETS));
            dispatch(setSelectedAsset(carriedOverAsset));
            dispatch(loadCapabilityAndKPIs(carriedOverAsset));
        } else if (new URLSearchParams(location.search).get('assetId')) {
            dispatch(setBrowserCategory(browserCategories.ASSETS));
            // AssetBrowserPanelContainer already snapshotted ?assetId= for its own deep-link
            // selection. Strip it from the URL now, before GeneralFilterModal's deferred
            // useLoadDefaultFilters effect (gated on the default org finishing to load) can see
            // it and kick off its slow cross-org asset-search flow — which otherwise resets
            // this page's state and stalls the asset browser for a long time.
            handleRemoveQueryParams(history);
        }

        return () => {
            actions.saveOnGraphToOffGraph();
            actions.resetChart();
            actions.onGraphClearStore();
        };
    }, []);

    return <CrossAssetAnalysisV2Component />;
};

const mapDispatchToProps = (dispatch) => ({
    actions: {
        clearStore: () => dispatch(clearStore()),
        onGraphClearStore: () => dispatch(onGraphClearStore()),
        saveOnGraphToOffGraph: () => dispatch(saveOnGraphToOffGraph()),
        resetChart: () => dispatch(resetChart())
    }
});

CrossAssetAnalysisV2Container.propTypes = {
    actions: PropTypes.shape({
        clearStore: PropTypes.func,
        onGraphClearStore: PropTypes.func,
        saveOnGraphToOffGraph: PropTypes.func,
        resetChart: PropTypes.func,
    })
};

export default connect(null, mapDispatchToProps)(
    withErrorBoundaryTrigger(CrossAssetAnalysisV2Container)
);
